import { type AppContext } from "~/lib/context";
import { logInfo } from "~/lib/logger";
import { sleep } from "~/lib/utils";

const EXIT_SUCCESS = 0;

export const handleGracefulExit = (ctx: AppContext): void => {
  const { redis } = ctx;

  process.on("SIGINT", async () => {
    logInfo(ctx, "[server] SIGINT received, exiting process");

    await ctx.prisma.$disconnect();
    redis.disconnect();

    // DD flush
    await sleep(1000);

    process.exit(EXIT_SUCCESS);
  });

  process.on("SIGTERM", async () => {
    logInfo(ctx, "[server] SIGTERM received, exiting process");

    await ctx.prisma.$disconnect();
    redis.disconnect();

    // DD flush
    await sleep(1000);

    process.exit(EXIT_SUCCESS);
  });
};
